import { Tooltip } from 'antd';
import { isEmpty, isEqual, sortBy } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { toggleWorkspaceFieldsModal } from '../../../../../actions';
import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskExtendedCustomFields } from '../../../../../redux/tasks/taskEntities/selectors';
import { getOpenedTaskProjectAndSectionLabelList } from '../../../../../redux/tasks/tasksToProjectsRelation/selectors';
import TaskCustomFields from '../TaskCustomFields';

const AddButtonLabel = ({ title, onClick, disabled, showIcon = true, isGuest }) => {
  if (isGuest) {
    return null;
  }

  return (
    <Tooltip title={!disabled && title}>
      <div
        className="flex items-center gap-1.5 px-2 py-0.5 rounded-lg cursor-pointer transition-colors"
        style={{
          background: 'rgba(99,102,241,0.07)',
          color: 'rgba(99,102,241,0.75)',
          border: '1px solid rgba(99,102,241,0.2)',
          fontSize: 12,
          fontWeight: 500,
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.13)'; e.currentTarget.style.color = '#4f46e5'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.07)'; e.currentTarget.style.color = 'rgba(99,102,241,0.75)'; }}
        onClick={onClick}
      >
        {showIcon && (
          <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 2a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 0 1 1-1z"/>
          </svg>
        )}
        <span>{title}</span>
      </div>
    </Tooltip>
  );
};

const TaskDetailsCustomFields = ({
  allProjects,
  extendedCustomFields,
  isGuest,
  projectAndSectionLabelList,
  projectId,
  taskId
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const [customFields, setCustomFields] = useState(extendedCustomFields || []);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (!isEqual(sortBy(customFields), sortBy(extendedCustomFields))) {
      setCustomFields(extendedCustomFields);
    }
  }, [customFields, extendedCustomFields]);

  useEffect(() => {
    setProjects(
      Object.values(projectAndSectionLabelList || {}).filter(
        (prj) => prj?.projectId || prj?._id,
      ),
    );
  }, [projectAndSectionLabelList]);

  const onAddFieldOpen = useCallback(() => {
    const taskProjectIds = Object.keys(projectAndSectionLabelList || {});
    dispatch(toggleWorkspaceFieldsModal(true, projectId, taskProjectIds.length ? taskProjectIds : null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, projectAndSectionLabelList])

  return (
    <>
      <div className="w-full mt-4 mb-2">
        <div className="flex justify-between align-center">
          <div className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: 'rgba(15,15,25,0.35)' }}>
            <FormattedMessage
              id="CUSTOM_FIELDS"
              defaultMessage="Custom Fields"
            />
          </div>
          {!isEmpty(projects) && (
            <div className="mr-4">
              <AddButtonLabel
                title={intl.formatMessage({
                  id: 'ADD_FIELD',
                  defaultMessage: 'Add Field',
                })}
                onClick={onAddFieldOpen}
                isGuest={isGuest}
              />
            </div>
          )}
        </div>
      </div>
      <div className="w-full">
        <TaskCustomFields
          id={taskId}
          customFields={customFields}
          projectCount={projectAndSectionLabelList}
          projects={allProjects}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  allProjects: state.workspaceReducer.workspaceProjects,
  extendedCustomFields: getOpenedTaskExtendedCustomFields(state),
  isGuest: state?.userReducer?.role === 'guest',
  projectAndSectionLabelList: getOpenedTaskProjectAndSectionLabelList(state),
  taskId: getOpenedTaskId(state),
});

export default connect(mapStateToProps)(TaskDetailsCustomFields);
